import React from 'react';
import { DialogProvider } from '@cnx-saas/common-fe';
import { AccountKeycloak } from './account-keycloak';

export function Account() {
  return (
    <DialogProvider>
      <AccountKeycloak />
    </DialogProvider>
  );
}
